import { defineComponent as G, ref as R, onMounted as T, onUnmounted as U, openBlock as D, createElementBlock as M, renderSlot as N } from "vue";
import j from "jquery";
import "slick-carousel";
const K = /* @__PURE__ */ G({
  __name: "Slick",
  props: {
    options: null
  },
  emits: ["afterChange", "beforeChange", "breakpoint", "destroy", "edge", "init", "reInit", "setPosition", "swipe", "lazyLoaded", "lazyLoadError"],
  setup(z, { expose: b, emit: s }) {
    const v = z, i = R(null), t = () => i.value ? j(i.value) : void 0, P = () => {
      var o;
      return (o = t()) == null ? void 0 : o.slick("slickCurrentSlide");
    }, E = (o, n) => {
      var e;
      (e = t()) == null || e.slick("slickGoTo", o, n);
    }, I = () => {
      var o;
      (o = t()) == null || o.slick("slickNext");
    }, S = () => {
      var o;
      (o = t()) == null || o.slick("slickPrev");
    }, _ = () => {
      var o;
      (o = t()) == null || o.slick("slickPause");
    }, w = () => {
      var o;
      (o = t()) == null || o.slick("slickPlay");
    }, B = (o, n, e) => {
      var r;
      (r = t()) == null || r.slick("slickAdd", o, n, e);
    }, O = (o, n) => {
      var e;
      (e = t()) == null || e.slick("slickRemove", o, n);
    }, m = (o) => {
      var n, e;
      typeof o == "string" ? (n = t()) == null || n.slick("slickFilter", o) : (e = t()) == null || e.slick("slickFilter", o);
    }, x = (o) => {
      var n;
      (n = t()) == null || n.slick("slickUnfilter", o);
    }, $ = (o) => {
      var n;
      return (n = t()) == null ? void 0 : n.slick("slickGetOption", o);
    }, A = (o, n, e) => {
      var r;
      (r = t()) == null || r.slick("slickSetOption", o, n, e);
    }, c = (o, n, e) => {
      s("afterChange", o, n, e);
    }, l = (o, n, e, r) => {
      s("beforeChange", o, n, e, r);
    }, a = (o, n, e) => {
      s("breakpoint", o, n, e);
    }, f = (o, n) => {
      s("destroy", o, n);
    }, d = (o, n, e) => {
      s("edge", o, n, e);
    }, k = (o, n) => {
      s("init", o, n);
    }, p = (o, n) => {
      s("reInit", o, n);
    }, u = (o, n) => {
      s("setPosition", o, n);
    }, y = (o, n, e) => {
      s("swipe", o, n, e);
    }, g = (o, n, e, r) => {
      s("lazyLoaded", o, n, e, r);
    }, C = (o, n, e, r) => {
      s("lazyLoadError", o, n, e, r);
    }, L = () => {
      var o, n;
      (n = t()) == null || n.on("afterChange", c).on("beforeChange", l).on("breakpoint", a).on("destroy", f).on("edge", d).on("init", k).on("reInit", p).on("setPosition", u).on("swipe", y).on("lazyLoaded", g).on("lazyLoadError", C).slick((o = v.options) != null ? o : {});
    }, h = () => {
      var o;
      (o = t()) == null || o.off("afterChange", c).off("beforeChange", l).off("breakpoint", a).off("destroy", f).off("edge", d).off("init", k).off("reInit", p).off("setPosition", u).off("swipe", y).off("lazyLoaded", g).off("lazyLoadError", C).slick("unslick");
    }, F = () => {
      h(), L();
    };
    return T(() => {
      L();
    }), U(() => {
      h();
    }), b({
      currentSlide: P,
      goTo: E,
      next: I,
      prev: S,
      pause: _,
      play: w,
      add: B,
      remove: O,
      filter: m,
      unfilter: x,
      getOption: $,
      setOption: A,
      reInit: F
    }), (o, n) => (D(), M("div", {
      ref_key: "root",
      ref: i
    }, [
      N(o.$slots, "default")
    ], 512));
  }
});
export {
  K as default
};
